import { useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function CardComponent(props) {
  const navigate = useNavigate();

  const goToDetails = () => {
    navigate("/Blog_detail", { myId: 55 });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="mb-[30px] ">
      {/* CARD */}
      <div className="shadow-lg bg-[#111527] rounded-lg overflow-hidden ">

        {/* IMAGE */}
        <img
          src={props.image}
          alt=""
          className="w-full h-[250px] md:h-[1000px] "
        />

        {/* BODY */}
        <div className="p-5">

          {/* TITLE */}
          <h3
            className="text-2xl font-semibold p-2 text-white hover:text-[#fd02fd] cursor-pointer"
            onClick={goToDetails}
          >
            {props.text2}
          </h3>

          {/* META TOP *
          <div className="mt-5 text-gray-600">
            <ul className="flex flex-wrap items-center list-none p-0 m-0 space-x-[20px]">

              <li className="flex items-center">
                <i className="bi bi-person text-[16px] mr-2 leading-none"></i>
                
                <a href="/blog-details" className="text-[14px] no-underline text-gray-500">
                  Ashish
                </a>
              </li>
           
              <li className="flex items-center">
                <i className="bi bi-clock text-[16px] mr-2 leading-none"></i>
                <a href="/blog-details" className="text-[14px] no-underline text-gray-500">
                  Jan 1, 2022
                </a>
              </li>

              <li className="flex items-center">
                <i className="bi bi-chat-dots text-[16px] mr-2 leading-none"></i>
                <a href="/blog-details" className="text-[14px] no-underline text-gray-500">
                  12 Comments
                </a>
              </li>

            </ul>
          </div>
               */}
          {/* DESCRIPTION */}
          <p className="p-2 my-1 text-gray-400">
            {props.text}
          </p>

          {/* BUTTON */}
          <div className="flex justify-end mt-3">
            <button
              className="px-7 py-3 rounded-xl text-white font-bold tracking-wide 
bg-gradient-to-r from-[#8A2EFF] to-[#FF00C8]
shadow-lg shadow-[#8A2EFF]/20 hover:shadow-[#FF00C8]/40 
hover:scale-90 transition-all duration-300"
              onClick={goToDetails}
            >
              Read More
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}








// bg-white/5